import { FC } from "react";
import { Formik, Form } from "formik";
import { useDispatch, useSelector } from "react-redux";

import Button from "../../components/Button/Button";
import { selectSuperuserLoading } from "../../store/selectors/superuser";
import FormikInputField from "../../components/FormikField/FormikInputField/FormikInputField";
import { superuserSchema } from "../../utils/validators";
import { impersonateUser } from "../../store/superuser/slice";
import SuperuserLayout from "../../layout/SuperuserLayout/SuperuserLayout";

import styles from "./Superuser.module.css";



const SuperuserView: FC = () => {
  const dispatch = useDispatch();
  const impersonationLoading = useSelector(selectSuperuserLoading);

  const initialValues = {
    email: '',
  };

  const handleSubmit = (values: typeof initialValues) => {
    dispatch(impersonateUser({ email: values.email }));
  };

  return (
    <SuperuserLayout>
      <div className={styles.superuser}>

        <Formik
          initialValues={initialValues}
          validationSchema={superuserSchema}
          enableReinitialize
          validateOnChange={false}
          validateOnBlur={false}
          onSubmit={handleSubmit}
        >
          {() => (
            <Form className={styles.form}>
              <div className={styles.form__field}>
                <FormikInputField label="Email" name="email" placeholder="Email" type="email" />
              </div>

              <Button 
                label={impersonationLoading ? "Loading..." : "Enable Superuser Mode"} 
                typeStyle="fill-dark" 
                size="lg" 
                className={styles.form__submit} 
                type="submit" 
                disabled={impersonationLoading} 
              />
            </Form>
          )}
        </Formik>

      </div>
    </SuperuserLayout>
  );
};

export default SuperuserView;
